import axiosInstance from "./axiosInstance";

// POST /api/posts/{id}/like/
export const likePost = async (postId) => {
  const response = await axiosInstance.post(`/posts/${postId}/like/`);
  return response.data;
};

// POST /api/posts/{id}/unlike/
export const unlikePost = async (postId) => {
  const response = await axiosInstance.post(`/posts/${postId}/unlike/`);
  return response.data;
};